module.exports = __webpack_public_path__ + "static/lila-38427f814a04d19c3566c3116832ce84.jpg";